// extracted by mini-css-extract-plugin
export default {"root":"CreateSaleOrderOverlay_root__uGU8E","info":"CreateSaleOrderOverlay_info__Fe8NH"};